<script lang="ts">
  import { route } from '$lib/state/route.svelte';
  import UsersPage from './UsersPage.svelte';
  import VerticalsPage from './VerticalsPage.svelte';
  import CatalogPage from './catalog/CatalogPage.svelte';
  import ActivityPage from './ActivityPage.svelte';
  import TermsTemplatesPage from './TermsTemplatesPage.svelte';

  const sub = $derived(route.current.tab === 'admin' ? (route.current.sub ?? 'users') : 'users');
</script>

<div class="pq-scroll flex-1 overflow-y-auto">
  {#if sub === 'verticals'}
    <VerticalsPage />
  {:else if sub === 'catalog'}
    <CatalogPage />
  {:else if sub === 'activity'}
    <ActivityPage />
  {:else if sub === 'terms-templates'}
    <TermsTemplatesPage />
  {:else}
    <UsersPage />
  {/if}
</div>
